import React, { PropsWithChildren } from 'react';
import { UListProps } from '../../../../types/HtmlProps';

type PersonInformationListProps = {
  headline: string;
};

export function PersonInformationList({
  headline,
  children,
  ...ulProps
}: PropsWithChildren<UListProps & PersonInformationListProps>) {
  return (
    <>
      <h4 className="invisible">{headline}</h4>
      <ul {...ulProps}>{children}</ul>
    </>
  );
}
